import * as React from "react";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Link as RouterLink, useLocation } from "react-router-dom";

const breadcrumbNameMap = {
    "/portfolio": "Portfolio",
    "/portfolio/activities": "Activities",
    "/portfolio/notes": "Notes",
    "/portfolio/resources": "Resources",
    "/portfolio/categories": "Categories",
    "/portfolio/pdps": "Personal development plans",
    "/portfolio/qualifications": "Qualifications",
    "/portfolio/developmentneeds": "Development needs",
};

const LinkRouter = (props) => <Link {...props} component={RouterLink} />;

const BreadcrumbBuilder = () => {
    const location = useLocation();
    const pathnames = location.pathname.split("/").filter((x) => x);

    return (
        <Breadcrumbs aria-label="breadcrumb">
            <LinkRouter underline="hover" color="inherit" to="/">
                Home
            </LinkRouter>
            {pathnames.map((value, index) => {
                const last = index === pathnames.length - 1;
                const to = `/${pathnames.slice(0, index + 1).join("/")}`;

                return last ? (
                    <Typography color="text.primary" key={to}>
                        {breadcrumbNameMap[to]}
                    </Typography>
                ) : (
                    <LinkRouter
                        underline="hover"
                        color="inherit"
                        to={to}
                        key={to}
                    >
                        {breadcrumbNameMap[to]}
                    </LinkRouter>
                );
            })}
        </Breadcrumbs>
    );
};

export default BreadcrumbBuilder;
